// @flow

type Severity = 'suppress' | 'warning' | 'error';

export default {
  get severity(): Severity {
    try {
      const localStorageVerboseFlag = localStorage.getItem('Z_PERF_SEVERITY');
      const severity: ?string =
        process.env.Z_PERF_SEVERITY || localStorageVerboseFlag;
      // $FlowFixMe because I want type checking for consumers
      return severity;
    } catch (e) {
      console.warn('Unable to read perf-utils severity level configuration');
      return 'suppress';
    }
  },
};
